
import React, { useState } from 'react'
import { Footer } from '../../../components/footer';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useSingleStakeHistory } from './api';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../Loader/buttonLoad';
import moment from 'moment';
import { useStakedIdRewardHistory } from '../redeem/api';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { useToast } from '../../../hook/usetoast';
import { Check } from 'lucide-react';


const StakingHistory = () => {

    const { stakeId } = useParams()
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const navigate = useNavigate()
    const { data: stakeDetail, isLoading } = useSingleStakeHistory({
        id: stakeId,
    })

    const { data: historyTableList, isFetching } = useStakedIdRewardHistory({
        page,
        size: rowsPerPage,
        type: "stake-reward",
        id: stakeId,
    })

    const stakeStatus = (i) => {
        return (!i?.isRewardForYear5) ? " Active" : " Expired";
    };

    const stakePercentage = (i) => {
        if (!i?.isRewardForYear1) {
            return i?.commissionForYear1
        } else if (!i?.isRewardForYear2) {
            return i?.commissionForYear2
        } else if (!i?.isRewardForYear3) {
            return i?.commissionForYear3
        } else if (!i?.isRewardForYear4) {
            return i?.commissionForYear4
        } else {
            return i?.commissionForYear5
        }
    };

    const toast = useToast();
    const [isCopied, setIsCopied] = useState(false)
    const [uniqueId, setUniqueId] = useState('')
    const copyuserAddress = async data => {
        setIsCopied(true)
        setUniqueId(data?._id)
        await copyToClipboard(data?.stakeId)
        toast.success("Copied Successfully")
        setTimeout(() => {
            setIsCopied(false)
        }, 300);
    }
    const totalPages = Math.ceil(historyTableList?.count / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };
    return (
        <>
            <div className="mainContent">
                {(isLoading || isFetching) && <Loader />}
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/staking-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Stake History</span>
                        </div>
                        <div className="appcard mb-4 p-3">
                            <div className="row align-items-center rightLevelcnt">
                                <div className="col-lg-auto col-md-auto">
                                    <div className="appDarkCard mb-3 mb-md-0">
                                        <div className="stakingwalletbx">
                                            <div className='d-flex align-items-center justify-content-between mb-4'>
                                                <div className='leftTxt'>Stake Amount</div>
                                                <div className={stakeStatus(stakeDetail?.data) === " Active" ? 'activeStaus text-right' : 'inActiveStaus text-right'}><span></span> {stakeStatus(stakeDetail?.data)}</div>
                                            </div>
                                            <div className="text-center">
                                                <div className='fs-26 fw-400'>{(stakeDetail?.data?.stakeAmount)?.toString().includes('.') ? parseFloat(stakeDetail?.data?.stakeAmount)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeDetail?.data?.stakeAmount} TPL</div>
                                                <div className='fs-14 fw-400'>{(stakeDetail?.data?.currUsdtValue)?.toString().includes('.') ? parseFloat(stakeDetail?.data?.currUsdtValue)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeDetail?.data?.currUsdtValue} USDT</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg col-md">
                                    <div className="row">
                                        <div className="col-md-4 col-sm-6 mb-3 mb-md-0">
                                            <div>
                                                <div className='labelTxt'>Stake Id</div>
                                                <div className='labelVal fs-18'>{stakeDetail?.data?.stakeId}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3 mb-md-0">
                                            <div>
                                                <div className='labelTxt'>Yield Value</div>
                                                <div className='labelVal fs-18'>{stakePercentage(stakeDetail?.data)}%</div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 ">
                                            <div>
                                                <div className='labelTxt'>Reward Earned</div>
                                                <div className='labelVal fs-18'>{(stakeDetail?.data?.rewardAmount)?.toString().includes('.') ? parseFloat(stakeDetail?.data?.rewardAmount)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeDetail?.data?.rewardAmount}  <span className='smTxt'>TPL</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className='cusHr' />
                                    <div className="row rightLevelcnt">
                                        <div className="col-md-4 col-sm-6 mb-3 mb-md-0">
                                            <div>
                                                <div className='labelTxt'>Start Date & Time</div>
                                                <div className='labelVal fs-18'>{moment(stakeDetail?.data?.createdAt).format("DD/MM/YYYY | hh:mm A")}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3 mb-md-0">
                                            <div>
                                                <div className='labelTxt'>End Date & Time</div>
                                                <div className='labelVal fs-18'>{moment(stakeDetail?.data?.endDate).format("DD/MM/YYYY | hh:mm A")}</div>
                                            </div></div>
                                            <div className="col-md-4 ">
                                            <div>
                                                <div className='labelTxt'>Total Capping</div>
                                                <div className='labelVal fs-18'>{(stakeDetail?.data?.totalCapping)?.toString().includes('.') ? parseFloat(stakeDetail?.data?.totalCapping)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeDetail?.data?.totalCapping}  <span className='smTxt'>TPL</span></div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 d-flex justify-content-between flex-wrap px-4 pb-0">
                                        <div className='bxTitle'>
                                            <span>Reward History</span>
                                        </div>
                                    </div>
                                    <div className="px-4 mb-3">
                                        <div className='row justify-content-between'>
                                            <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                <div className='d-inline-flex g-8 align-items-center'>
                                                    <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                    <div className='form-group mb-0 formInputs gradientBg'>
                                                        <select className='form-control' value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)}>
                                                            <option value="10">10</option>
                                                            <option value="30">30</option>
                                                            <option value="50">50</option>
                                                        </select>
                                                    </div>
                                                    <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='table-responsive mb-3'>
                                        <table className='table myapptable table-hover table-borderless mb-0'>
                                            <thead>
                                                <tr>
                                                    <th className='pl-4'>Stake Id</th>
                                                    <th className='text-nowrap'>Capping Available</th>
                                                    <th className='text-nowrap'>Reward Amount</th>
                                                    <th>Yield</th>
                                                    <th className='text-nowrap'>Stake Reward</th>
                                                    <th>Date & Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historyTableList?.data?.length > 0 ? historyTableList?.data?.map((i) =>
                                                    <tr key={i}>
                                                        <td className='pl-4'> 
                                                        <div className="d-flex g-10 text-nowrap"><span>{i.stakeId}</span><button className='btn btnEmpty' onClick={() => copyuserAddress(i)} onKeyDown={(e) => e.key === 'Enter' && copyuserAddress(i?.stakeId)}>{(isCopied && uniqueId === i?._id) ? <Check size={20} color={"#FCD535"} cursor={'not-allowed'} /> :
                                                            <img src={require('../../../assets/images/master-wallet/copyIcon.svg').default} alt='copyIcon' aria-label="Copy Transaction ID"
                                                            />}</button></div></td>
                                                        <td className='text-nowrap'>{(i?.cappingAvailable)?.toString().includes('.') ? parseFloat(i?.cappingAvailable)?.toFixed(5).replace(/(\.0+)?$/, '') : i?.cappingAvailable}
                                                        <span className="text-white-60"> TPL</span></td>
                                                        <td className='text-nowrap'>{(i?.stakeAmount)?.toString().includes('.') ? parseFloat(i?.stakeAmount)?.toFixed(5).replace(/(\.0+)?$/, '') : i?.stakeAmount}
                                                            <span className="text-white-60"> TPL</span></td>
                                                        <td className='text-nowrap'>{(i?.Yield)?.toString().includes('.') ? parseFloat(i?.Yield)?.toFixed(5).replace(/(\.0+)?$/, '') : i?.Yield}
                                                            <span className="text-white-60"> %</span></td>
                                                        <td className='text-nowrap'>{(i?.rewardAmount)?.toString().includes('.') ? parseFloat(i?.rewardAmount)?.toFixed(5).replace(/(\.0+)?$/, '') : i?.rewardAmount}
                                                            <span className="text-white-60"> TPL</span></td>
                                                        <td className='text-nowrap'>{moment(i.createdAt).format("DD/MM/YYYY | hh:mm A")}</td>

                                                    </tr>
                                                ) :
                                                    (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No data found</td>
                                                        </tr>
                                                    )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="px-4">
                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <Pagination aria-label="Page navigation" className='customPagination'>
                                                    <PaginationItem disabled={page === 0}>
                                                        <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                            <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                        </PaginationLink>
                                                    </PaginationItem>

                                                    {page < 3 ? (
                                                        Array.from({ length: Math.min(3, totalPages) }, (_, index) => (
                                                            <PaginationItem key={index} active={index === page} className={`${index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                    {index + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        ))
                                                    ) : (
                                                        <>
                                                            {page > 0 && (
                                                                <PaginationItem key={0} className="customPagination">
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                                        1
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            )}

                                                            {page > 1 && (
                                                                <PaginationItem disabled>
                                                                    <PaginationLink href="#">...</PaginationLink>
                                                                </PaginationItem>
                                                            )}

                                                            {Array.from({ length: 3 }, (_, index) => (
                                                                <PaginationItem key={page - 1 + index} active={page - 1 + index === page} className={`${page - 1 + index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(page - 1 + index)}>
                                                                        {page - 1 + index + 1}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            ))}

                                                            {page < totalPages - 2 && (
                                                                <PaginationItem disabled>
                                                                    <PaginationLink href="#">...</PaginationLink>
                                                                </PaginationItem>
                                                            )}

                                                            {page < totalPages - 1 && (
                                                                <PaginationItem key={totalPages - 1} className="customPagination">
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                                        {totalPages}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            )}
                                                        </>
                                                    )}

                                                    <PaginationItem disabled={page === totalPages - 1}>
                                                        <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                            Next <i className='bi bi-arrow-right align-bottom'></i>
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                </Pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default StakingHistory;